import { IncomeItem, IncomeType, VerifyMethodType } from "shared/types";
import { CombinedIncomeSubStep } from "../../constants";

export enum DocumentType {
  Paystub = "paystub",
  W2 = "w2",
  BankStatement = "bank_statement",
  HousingAssistance = "housing_assistance",
  BenefitsStatement = "benefits_statement",
  OfferLetter = "offer_letter"
}

export interface IncomeDocument {
  source?: string;
  document_type: string;
  url: string;
  metadata: {
    size: number;
    original_filename: string;
    content_type: string;
  };
}

export interface CombinedIncomeStepData {
  lastStep?: CombinedIncomeSubStep;
  currentDocumentType?: DocumentType | null;
  currentIncomeType?: IncomeType | null;
  currentIncomeId?: number | null;
  company_name?: string;
  job_title?: string;
  start_date?: string;
  supervisor?: {
    first_name: string;
    last_name: string;
    contact_email: string;
    contact_phone: string;
  };
  description?: string;
  paid_from?: string;
  pay_period?: string;
  amount?: string;
  documents?: IncomeDocument[];
  income_source_type?: VerifyMethodType;
}

export type CreateIncomePayload = Omit<IncomeItem, "id" | "status">;

export interface NavigationData {
  hasIncome?: boolean;
  incomeType?: IncomeType | null;
  skipSupervisorDetails?: boolean;
  skipHousingAssistance?: boolean;
}

type FlowCondition = {
  condition: (data?: NavigationData) => boolean;
  target: CombinedIncomeSubStep;
};

export type FlowStep = {
  next?: CombinedIncomeSubStep | FlowCondition[];
  back?: CombinedIncomeSubStep | FlowCondition[];
};

export enum CombinedIncomeMode {
  ManualApplication,
  AddNewIncomeSource
}
